module.exports = __webpack_public_path__ + "assets/img/e495-hn.svg";